// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".FeedFilters-cls1___87e6588cf36003799ee{/*!*/}.FeedFilters-cls2___b927f5f9c80b920c1ab{display:flex;flex-wrap:wrap;grid-gap:8px;gap:8px;padding:0 16px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "FeedFilters-cls1___87e6588cf36003799ee",
	"cls2": "FeedFilters-cls2___b927f5f9c80b920c1ab FeedFilters-cls1___87e6588cf36003799ee"
};
export default ___CSS_LOADER_EXPORT___;
